<div id="fullscreen-loader" *ngIf="!inlineLoader">
  <div class="align-absolute-center">
    <div class="loader"></div>
  </div>
</div>

<div class="inline-loader" *ngIf="inlineLoader">
    <div class="loader" ></div>
</div>
